import ActiveController from "rapid/controller";
import {countries} from "./countries";

export class addressController extends ActiveController {
	constructor($injector, $rootScope, $element, $scope) {
		"ngInject";
		super($injector);

		this.$rootScope = $rootScope;
		this.$element = angular.element($element);
		this.$scope = $scope;
		this.countries = countries;

		this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));

		this.initial = {
			locationName: "",
			street: "",
			houseNo: "",
			zipCode: "",
			city: "",
			country: ""
		};
	}

	$onInit() {
		typeof this.location === "undefined" && (this.location = false);

		this.$scope.$watch(() => this.model, () => {
			this.model = {...this.initial, ...this.model};
		}, true);

	}


}



// WEBPACK FOOTER //
// ./sources/components/common/address/address.controller.js